import base from '../base'

const signup = (params) => {
  return base.post('/users/signup', params).then(resp => resp)
}

export default {
  signup: signup,
}
